import React from "react";
import { useConsolidationPreference } from "../../hooks/useConsolidationView.js";
import DispatchGanttPreview from "./DispatchGanttPreview.jsx";

export default function CollapsibleDispatchGantt({ stateKey, children, ...previewProps }) {
  const [open, setOpen] = useConsolidationPreference(`open:gantt:${stateKey}`);
  const [openedOnce, setOpenedOnce] = React.useState(open);
  return <details open={open} className="min-w-0 rounded-[4px] border border-slate-200 bg-white" onToggle={(event) => {
    if (event.target !== event.currentTarget) return;
    setOpen(event.currentTarget.open);
    if (event.currentTarget.open) setOpenedOnce(true);
  }}>
    <summary className="cursor-pointer rounded-[4px] px-3 py-2 text-xs font-medium text-slate-700 focus-visible:outline-2 focus-visible:outline-accent">Gantt du Dispatch</summary>
    {open || openedOnce ? <div className="min-w-0 px-2 pb-2">{children ?? <DispatchGanttPreview {...previewProps} />}</div> : null}
  </details>;
}
